// extracted by mini-css-extract-plugin
export default {"fullWidth":"Cp-z","image":"Dp-z","lazyLoadPicture":"Ep-z","lazyLoadSpinner":"Fp-z","lazyLoadSpin":"Gp-z","lazyLoadImage":"Hp-z","hasStyledAspectRatio":"Ip-z"};